<template>
  <div class="starter-page">
    <user-picker-modal
      v-if="modal.task"
      :visible="modal.assignedBy"
      :title="modal.title"
      role="ASSIGNER"
      :multi="false"
      v-model="modal.task.assignedBy"
      @okClicked="_onModalAssignedByOKClicked"
      @closeClicked="modal.assignedBy = false"
    />

    <user-picker-modal
      v-if="modal.task"
      :visible="modal.assignedTo"
      :title="modal.title"
      role="ASSIGNEE"
      :multi="false"
      v-model="modal.task.assignedTo"
      @okClicked="_onModalAssignedToOKClicked"
      @closeClicked="modal.assignedTo = false"
    />

    <portal to="sidebar" v-if="project && showFinance">
      <finance
        :show="showFinance"
        @outSideClicked="showFinance = false"
        :fullWidth="false"
        :project="project"
        @paymentSuccess="_onPaymentSuccess"
        @inviteSuccess="_onInviteSuccess"
      />
    </portal>

    <portal to="sidebar" v-if="project && showApproval">
      <approval
        :show="showApproval"
        @outSideClicked="showApproval = false"
        :fullWidth="false"
        :project="project"
        @approveSuccess="_onApproveSuccess"
        @inviteSuccess="_onInviteSuccess"
      />
    </portal>

    <portal to="sidebar" v-if="project && showAcceptance">
      <acceptance
        :show="showAcceptance"
        @outSideClicked="showAcceptance = false"
        :fullWidth="false"
        :project="project"
        @onAccept="_onAcceptClicked"
        @onReject="_onCancelTermsClicked"
        :budget="taskBudget"
        :tasks="approvalTasks"
        @paymentSuccess="_onPaymentSuccess"
      />
    </portal>

    <portal to="sidebar" v-if="project && showCardUpdate">
      <CardUpdate
        :show="showCardUpdate"
        @outSideClicked="showCardUpdate = false"
        :fullWidth="false"
        :project="project"
        @updateSuccess="_onUpdateCardSuccess"
      />
    </portal>

    <!-- <div
      class="navbar-dark project-header py-2 px-4 d-flex justify-content-end test22"
    >
      <div
        class="gantt-title-wrapper"
        @click="$router.push({ name: 'projects' }).catch(() => {})"
        style="cursor: pointer;"
      >
        <a
          v-if="
            query && Object.keys(query).length == 0 && !searchResults && false
          "
        >
          <img
            class="icon icon-xs"
            src="@/assets/img/icons/svgs/solid/left-arrow.svg"
          />
        </a>
        <a
          v-if="
            query && Object.keys(query).length > 0 && searchResults && false
          "
          @click="_onResetSearchClicked"
        >
          <img
            class="icon icon-xs"
            src="@/assets/img/icons/svgs/solid/left-arrow.svg"
          />
        </a>
        <span
          v-if="project && false"
          class="align-middle ticket-title__client-name pl-0"
          v-html="title"
        ></span
        ><span v-if="!ganttView && false" style="padding-left:4px;"
          >Quote &nbsp; - &nbsp;
        </span>
        <div v-if="project && project.user_owner && false">
          <user-avatar
            :data="project.user_owner"
            :title="userRoleDescription(project.user_owner, 'Project Manager')"
          />
        </div>
        <div
          v-if="
            project && project.approver && project.payment_status == 'SUCCESS'
          "
        >
          <user-avatar
            :data="project.approver"
            :title="userRoleDescription(project.approver, 'Client')"
          />
        </div>

        <div
          v-if="
            project &&
              project.financePayer &&
              project.payment_status != 'SUCCESS'
          "
        >
          <user-avatar
            :data="project.financePayer"
            :title="
              userRoleDescription(project.financePayer, 'Finance Administrator')
            "
          />
        </div>

      </div>

      <div class="d-flex align-items-center">
       
        <button
          class="btn btn-sm text-white bg-green my-2 mt-2 mb-2 ml-2 my-md-0"
          type="button"
          v-if="ganttView"
          data-toggle="tooltip"
          data-placement="top"
          @click="_onFinanceClicked"
        >
          {{ projectBudget.label }}
        </button>

      

        <div v-if="!ganttView && false">
          <base-button
            v-if="
              project.payment_status == 'SUCCESS' &&
                project.approval_status != 'APPROVED' &&
                project.user_owner &&
                project.user_owner.user.id == profile.id
            "
            size="sm"
            @click="_onRequestApprovalClicked"
            type="danger"
            >Request Approval</base-button
          >

          <base-button
            v-if="
              project.payment_status != 'SUCCESS' &&
                project.user_owner &&
                project.user_owner.user.id == profile.id
            "
            size="sm"
            @click="_onPaymentClicked"
            type="danger"
            >Request Approval</base-button
          >

          <div
            v-if="
              project.payment_status != 'SUCCESS' &&
                project.financePayer &&
                project.financePayer.user.id == profile.id
            "
          >
            <base-button size="sm" @click="_onPaymentClicked" type="success"
              >Proceed Payment</base-button
            >
          </div>

          <div
            v-if="
              project.payment_status == 'SUCCESS' &&
                project.approver &&
                project.approver.user.id == profile.id
            "
          >
            <base-button size="sm" @click="_onAcceptanceClicked" type="success"
              >Approve Selected</base-button
            >

            <el-popover title="Rejection Note" placement="bottom" width="400">
              <div
                class="d-flex flex-column justify-content-end align-items-end"
              >
                <html-editor v-model="project.reject_reason" class="w-100" />

                <base-button size="sm" @click="_onRejectClicked" type="primary"
                  >Submit</base-button
                >
              </div>

              <base-button size="sm" type="danger" slot="reference"
                >Reject Selected</base-button
              >
            </el-popover>
          </div>
        </div>
      </div>
    </div> -->

    <div class="d-flex flex-column justify-start">
      <table-view-preview
        @taskCreated="refreshRecords"
        :project="project"
        :tasks="searchResults"
        @paymentSuccess="refreshRecords"
        @approveSuccess="refreshRecords"
        v-if="
          query &&
            Object.keys(query).length > 0 &&
            searchResults &&
            profile &&
            !ganttView &&
            previewMode
        "
      />

      <table-view
        @taskCreated="refreshRecords"
        @taskDeleted="refreshRecords"
        @projectUpdated="refreshRecords"
        :project="project"
        :tasks="searchResults"
        @selectAllClicked="_onSelectAllClicked"
        v-if="
          query &&
            Object.keys(query).length > 0 &&
            searchResults &&
            profile &&
            !ganttView &&
            !previewMode
        "
      />
      <Gantt
        ref="ab"
        v-if="
          query &&
            Object.keys(query).length > 0 &&
            searchResults &&
            profile &&
            ganttView
        "
        :enableResize="true"
        :currency="profile.currency"
        :ganttView="profile.ganttViewMode"
        :ganttDay="profile.ganttDayMode"
        :ganttComment="
          profile && profile.role && profile.role.name != 'guest'
            ? profile.ganttCommentMode
            : 'task-title'
        "
        :ganttZoom="profile.ganttZoomMode"
        :showBilling="profile.showFinance == '1'"
        :tasks="searchResults"
        :showAssignedTo="true"
        color-class="projectGantt"
        @task-dragged="handleTaskDragged"
        @task-link-clicked="handleTaskLinkClick"
        @task-dbl-click="handleTaskDblClick"
        @assigned-by-user-clicked="handleAssignedByUserClicked"
        @assigned-to-user-clicked="handleAssignedToUserClicked"
      />

      <table-view-preview
        @taskCreated="refreshRecords"
        :project="project"
        :tasks="tasks"
        @approveSuccess="refreshRecords"
        @paymentSuccess="refreshRecords"
        v-if="tasks && profile && !ganttView && previewMode"
      />

      <table-view
        @taskCreated="refreshRecords"
        @taskDeleted="refreshRecords"
        @projectUpdated="refreshRecords"
        :project="project"
        :tasks="tasks"
        @selectAllClicked="_onSelectAllClicked"
        @approveClicked="_onAcceptanceClicked"
        @overDueClicked="_onOverDueClicked"
        v-if="tasks && profile && !ganttView && !previewMode"
      />

      <Gantt
        ref="aa"
        v-if="tasks && profile && ganttView"
        :currency="profile.currency"
        :enableResize="true"
        :ganttView="profile.ganttViewMode"
        :ganttDay="profile.ganttDayMode"
        :ganttComment="
          this.profile && this.profile.role && this.profile.role.name != 'guest'
            ? profile.ganttCommentMode
            : 'task-title'
        "
        :ganttZoom="profile.ganttZoomMode"
        :showBilling="profile.showFinance == '1'"
        :tasks="tasks"
        :showAssignedTo="true"
        color-class="projectGantt"
        @task-dragged="handleTaskDragged"
        @dblClickEmptyArea="handleTaskDblClick"
        @task-link-clicked="handleTaskLinkClick"
        @task-dbl-click="handleTaskDblClick"
        @assigned-by-user-clicked="handleAssignedByUserClicked"
        @assigned-to-user-clicked="handleAssignedToUserClicked"
      />
    </div>

    <div
      class="project__details text-primary text-lg font-weight-light"
      v-if="tasks && ganttView"
    >
      Total
      <b
        class="font-weight-bold"
        v-if="
          query &&
            (!query.q || query.q == '' || Object.keys(query).length > 0) &&
            searchResults &&
            profile
        "
        >{{ searchResults.data.length }}</b
      >

      <b
        class="font-weight-bold"
        v-if="
          query &&
            (!query.q || query.q == '' || Object.keys(query).length > 0) &&
            tasks &&
            profile
        "
        >{{ tasks.data.length }}</b
      >
      Bracket(s)
    </div>
  </div>
</template>
<script>
import Gantt from "@/app/components/Gantt.vue";
import { mapMutations, mapState, mapActions } from "vuex";
import moment from "moment";
import TableView from "../components/TableView.vue";
import TableViewPreview from "../components/TableViewPreview.vue";
import UserPickerModal from "../components/UserPickerModal.vue";
import { isMobile } from "mobile-device-detect";
import Finance from "../components/Finance.vue";
import Approval from "../components/Approval.vue";
import Acceptance from "../components/Acceptance.vue";
import CardUpdate from "../components/CardUpdate.vue";
import swal from "sweetalert2";
import HtmlEditor from "../../components/Inputs/HtmlEditor.vue";
import UserAvatar from "@/app/components/UserAvatar.vue";

export default {
  name: "TasksHome",
  props: ["taskCreateFlag"],
  components: {
    Gantt,
    TableView,
    UserPickerModal,
    TableViewPreview,
    HtmlEditor,
    Finance,
    Approval,
    Acceptance,
    CardUpdate,
    UserAvatar
  },
  data() {
    return {
      query: null,
      searchResults: null,
      ganttView: true,
      previewMode: false,
      isMobile: isMobile,
      project_quoted_hours: 0,
      modal: {
        visible: false,
        title: "Change User",
        role: "ASSIGNEE",
        task: null
      },
      showFinance: false,
      showApproval: false,
      showAcceptance: false,
      showCardUpdate: false,
      selectedTask: null,
      approvalTasks: []
    };
  },
  computed: {
    ...mapState("task", ["tasks"]),
    ...mapState("project", ["project"]),
    ...mapState("user", ["profile"]),
    ...mapState(["ganttRender"]),

    searchMode() {
      return (
        (this.$route.query && Object.keys(this.$route.query).length > 0) ||
        (this.$route.query &&
          Object.keys(this.$route.query).length > 0 &&
          (this.$route.query.archiveProjectTitle ||
            this.$route.query.activeProjectTitle ||
            this.$route.query.searchTaskTitle ||
            this.$route.query.searchTaskText))
      );
    },

    title() {
      let t = this.$route.params.name
        ? this.$route.params.name
        : this.project.name;
      if (
        this.$route.query &&
        Object.keys(this.$route.query).length > 0 &&
        this.searchResults
      ) {
        t +=
          "/ " +
          this.searchResults.data.length +
          " Search Results" +
          (this.$route.query && this.$route.query.q
            ? " for " + this.$route.query.q
            : "");
      }
      return t;
    },

    taskBudget() {
      let totalHours = 0;
      let totalCost = 0;
      let tasks = this.approvalTasks || [];

      tasks.map(t => {
        let tc = parseFloat((t.hourly_cost || 0) * (t.quoted_hours || 0));
        totalHours = parseInt(t.quoted_hours || 0);
        let dp = isNaN(parseInt(t.discount_percentage))
          ? 0
          : parseInt(t.discount_percentage);
        dp = 0; //for now make all discount 0 as i dont see this in new design
        const numOfDays = parseInt(t.no_of_days || 1);
        const teamSize = parseInt(t.total_team_members || 1);
        //totalCost += (tc - (tc * dp) / 100);
        totalCost += tc;
        //totalCost = totalCost.toFixed(2);
        console.log(dp, t.no_of_days, "project budget");
      });

      if (totalCost >= 1000) {
        totalCost = (totalCost / 1000).toFixed(2) + "k";
      } else {
        totalCost = totalCost.toFixed(2);
      }

      return {
        label:
          totalHours +
          " Hours" +
          " | " +
          (this.profile && this.profile.currency.symbol) +
          totalCost,
        hours: totalHours,
        cost: totalCost
      };
    },

    projectBudget() {
      let totalHours = 0;
      let totalCost = 0;
      let tasks = (this.tasks && this.tasks.data) || [];

      tasks.map(t => {
        let tc = parseFloat((t.hourly_cost || 0) * (t.quoted_hours || 0));
        totalHours = parseInt(t.quoted_hours || 0);
        let dp = isNaN(parseInt(t.discount_percentage))
          ? 0
          : parseInt(t.discount_percentage);
        dp = 0; //for now make all discount 0 as i dont see this in new design
        const numOfDays = parseInt(t.no_of_days || 1);
        const teamSize = parseInt(t.total_team_members || 1);
        //totalCost += (tc - (tc * dp) / 100);
        totalCost += tc;
        //totalCost = totalCost.toFixed(2);
        console.log(dp, t.no_of_days, "project budget");
      });

      if (totalCost >= 1000) {
        totalCost = (totalCost / 1000).toFixed(2) + "k";
      } else {
        totalCost = totalCost.toFixed(2);
      }

      return {
        label:
          totalHours +
          " Hours" +
          " | " +
          (this.profile && this.profile.currency.symbol) +
          totalCost,
        hours: totalHours,
        cost: totalCost
      };
    }
  },
  watch: {
    taskCreateFlag(val) {
      this.fetchAllTasksByProjectId(this.$route.params.id).then(r => {
        this.setGanttRender();
      });
    },
    "$route.query"(val) {
      console.log("query changed", val);
      this.query = val;
      this.refreshRecords();
    },

    "$route.name"(val) {
      console.log("route name changed", val);
      this.ganttView = val == "tasks.home";
    }
  },
  mounted() {
    this.query = this.$route.query;
    this.$nextTick(async () => {
      this.query = this.$route.query;
      console.log(this.$route, "route");
      if (this.$route.name == "tasks.quote") {
        this.ganttView = false;
      }
      console.log(this.$route, "query sagar");
      if (this.$route.query.preview) {
        this.ganttView = false;
        this.previewMode = true;
      }
      this.setLoading(true);

      await this.refreshRecords();
      await this.fetchRoles();
      this.setLoading(false);

      if (this.$route.params.showThread) {
        this.handleTaskLinkClick(this.$route.params.threadId);
      }

      if (this.$route.params.screen == "payment-request") {
        this.showFinance = true;
      } else if (
        this.$route.params.screen == "quote-approval-request" ||
        this.$route.params.screen == "approval-request" ||
        this.$route.params.screen == "quote-approval-reject" ||
        this.$route.params.screen == "quote-approval-accept"
      ) {
        this.ganttView = false;
      }

      if (this.$route.query.success == "true") {
        this.ganttView = false;
        this.showAcceptance = true;
      }

      if (this.$route.query.return == "true") {
        this.ganttView = false;
      }
    });
  },
  methods: {
    ...mapActions("task", [
      "fetchAllTasks",
      "fetchSingleTask",
      "fetchAllTasksByProjectId",
      "updateTask",
      "updateTaskStatus",
      "searchTask"
    ]),

    ...mapActions("project", [
      "fetchSingleProject",
      "changeApprovalStatus",
      "changeApprovalStatusV2",
      "fetchProjectHistories"
    ]),
    ...mapActions("user", ["connectStripe", "checkoutStripe"]),

    ...mapMutations("task", ["setTasks"]),
    ...mapMutations(["setGanttRender", "setLoading"]),
    ...mapActions("common", ["fetchRoles"]),

    _onSelectAllClicked(tasks, status) {
      if (
        this.searchResults &&
        this.searchResults.data &&
        this.searchResults.data.length > 0
      ) {
        let data = this.searchResults.data.map(t => {
          if (t.approval_status != "APPROVED" && t.status != "CLOSED")
            t.approval_checked = status;

          return t;
        });

        this.searchResults = { data: data };
      } else {
        let data = this.tasks.data.map(t => {
          if (t.approval_status != "APPROVED" && t.status != "CLOSED")
            t.approval_checked = status;

          return t;
        });

        this.setTasks({ data: data }); //update store
      }
    },

    _onResetSearchClicked() {
      this.setLoading(true);
      this.$router
        .replace({
          name: "tasks.home",
          params: this.$route.params,
          query: null
        })
        .catch(() => {});
    },

    async refreshRecords() {
      try {
        await this.fetchSingleProject(
          this.$route.params.id,
          this.$route.name == "tasks.quote"
        );
      } catch (e) {
        console.log(e.response.status, this.profile, "fetching failed");
        //alert(this.profile.role.name)
        if (e.response && e.response.status == 401) {
          if (
            this.profile &&
            this.profile.role &&
            this.profile.role.name == "guest"
          ) {
            this.setLoading(false);
            this.$router.push({
              name: "projects",
              query: { login: true, redirect: this.$route.fullPath }
            });

            return false;
          }
        }
      }

      await this.fetchProjectHistories(this.$route.params.id);
      if (this.searchMode) {
        console.log("ddddddd", this.$route.query);
        let result = await this.searchTask({
          id: this.$route.params.id,
          ...this.$route.query
        });
        this.searchResults = result;
        return Promise.resolve(result);
      } else {
        this.fetchAllTasksByProjectId(
          this.$route.params.id,
          this.taskLoadingFlag
        ).then(r => {
          //this.$refs.aa.initGantt()
          this.setGanttRender();
          return Promise.resolve(r);
          //alert("hi")
        });
      }
    },

    avatarPrefix(model) {
      if (!model) return "";
      let ch = model.user.first_name.substring(0, 1).toUpperCase();

      return (
        model.user.first_name.substring(0, 1).toUpperCase() +
        (
          (model.user.last_name && model.user.last_name.substring(0, 1)) ||
          ""
        ).toUpperCase()
      );
    },

    userRoleDescription(model, type) {
      if (!model) return "";
      return (
        (model.user && model.user.id == this.profile.id
          ? "You are "
          : model.user.first_name + " is") +
        " the " +
        type +
        " of this project."
      );
    },

    async _onModalAssignedByOKClicked(assetUser) {
      this.modal.task.assignedBy = assetUser;
      this.modal.assignedBy = false;
      if (this.modal.task.discount_percentage == "N/A") {
        this.modal.task.discount_percentage = 0;
      }

      try {
        let res = await this.updateTask(this.modal.task);
        this.$snack.success("Assigned By User changed successfully");
        await this.refreshRecords();
        this.setGanttRender();
      } catch (e) {
        console.log(e, "error updating task");
      }
    },

    async _onModalAssignedToOKClicked(assetUser) {
      console.log("Assigned to used", assetUser);
      this.modal.task.assignedTo = assetUser;
      if (this.modal.task.discount_percentage == "N/A") {
        this.modal.task.discount_percentage = 0;
      }

      this.modal.assignedTo = false;
      try {
        let res = await this.updateTask(this.modal.task);
        this.$snack.success("Assigned To User changed successfully");
        await this.refreshRecords();
        this.setGanttRender();
      } catch (e) {
        console.log("error updating task");
      }
    },

    handleDblClick() {
      this.$emit("dblClick");
    },

    handleTaskDragged(id, e) {
      console.log(id, e);
      //let tasks = this.tasks.data.filter((t) => t.id == id);
      let body = e;
      //
      if (
        this.profile &&
        this.profile.role &&
        this.profile.role.name != "guest" &&
        body &&
        body.permission &&
        body.permission.edit == 1
      ) {
        body.start_date = moment(e.start_date).format("YYYY-MM-DD 00:00:00");
        body.end_date = body.deadline = moment(e.end_date)
          .add(-1, "days")
          .format("YYYY-MM-DD 23:59:59");

        this.updateTaskStatus(body).then(r => {
          //this.$snack.success("Task Updated Successfully")
          //this.setGanttRender();
        });
      } else {
        this.$snack.success(
          "This task is read only, so changes will not be saved"
        );
      }
    },
    handleTaskDblClick(id, event) {
      //if(id)
      //alert("v"+id)

      this.$emit(
        "taskDblClick",
        {
          id: id,
          project_id: this.project.id,
          name: this.$route.params.name
            ? this.$route.params.name
            : this.project.name
        },
        event
      );
    },

    _onFinanceClicked(event) {
      if (this.canEdit) {
        this.$router.push({ name: "tasks.quote" });
      } else if (
        this.project.approval_status != "APPROVED" &&
        this.project.payment_status == "SUCCESS" &&
        this.project.approver &&
        this.project.approver.user.id == this.profile.id
      ) {
        this.$router.push({ name: "tasks.quote" });
      }
      //this.$emit("financeClicked", {project_id: this.project.id, name: this.$route.params.name?this.$route.params.name:this.project.name}, event);
    },

    canEdit() {
      let isOwner =
        this.project.user_owner &&
        this.project.user_owner.user.id == this.profile.id;
      let isContributor = (this.project.contributors || []).some(
        c => c.user.id == this.profile.id
      );
      return (
        this.project.approval_status != "APPROVED" &&
        ((this.project.permission && this.project.permission.edit == 1) ||
          isOwner ||
          isContributor)
      );
    },

    onEmptyAreaDblClicked() {
      //alert("a");
      this.$emit(
        "taskDblClick",
        {
          id: null,
          project_id: this.project.id,
          name: this.$route.params.name
            ? this.$route.params.name
            : this.project.name
        },
        event
      );
    },

    handleTaskLinkClick(id, task) {
      // this.$router.push("/projects/" + this.project.id + "/tasks/" + id);
      this.$emit(
        "taskDblClick",
        {
          id: id,
          project_id: this.project.id,
          name: this.$route.params.name
            ? this.$route.params.name
            : this.project.name
        },
        event
      );
    },

    handleAssignedToUserClicked(id, userId, task) {
      console.log(task, id, "avatar clicked assigned to");
      if (task.permission && task.permission.edit == 1) {
        //this.$emit("assignedToUserClicked", id, userId, task);
        this.modal = {
          ...this.modal,
          task: task,
          title: "Search New Assigned To User",
          assignedTo: true,
          role: "ASSIGNEE"
        };
      } else {
        this.$snack.success("You can not edit this task.");
      }
    },

    _onPaymentClicked() {
      this.showFinance = true;
      this.showApproval = false;
    },

    _onCancelTermsClicked() {
      this.showAcceptance = false;
    },

    _onRequestApprovalClicked() {
      this.showApproval = true;
      this.showFinance = false;
    },

    async _onRejectClicked() {
      swal({
        title: "Are you sure to reject?",
        text: `Please click submit to proceed!`,
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Reject!",
        buttonsStyling: false
      }).then(async result => {
        if (result.value) {
          try {
            let res = await this.changeApprovalStatusV2({
              id: this.project.id,
              approval_status: "REJECTED",
              reject_reason: this.project.reject_reason,
              tasks: this.searchMode ? this.searchResults.data : this.tasks.data
            });

            this.$snack.success("Rejected Successfully");
            this._onApproveSuccess();
          } catch (e) {
            console.log(e);
            this.$snack.success("Error rejecting approval request");
          }
        }
      });
    },

    _onAcceptanceClicked(tasks) {
      this.showFinance = false;
      this.showApproval = false; //depriciated
      this.showAcceptance = true;
    },

    _onOverDueClicked() {
      this.showAcceptance = false;
      this.showCardUpdate = true;
    },

    async _onAcceptClicked(data) {
      // try {
      //   let res = await this.changeApprovalStatusV2({
      //     id: this.project.id,
      //     approval_status: 'APPROVED',
      //     tasks: this.searchMode?this.searchResults.data : this.tasks.data
      //   })
      //    this.$snack.success("Accepted Successfully")
      //    this._onApproveSuccess()
      // } catch(e) {
      //   console.log(e)
      //   this.$snack.success("Error accepting approval request")
      // }
      // try {
      //   let res = await this.checkoutStripe(data);
      //   console.log("stripe checkout ", res)
      //   //this.$snack.success("Accepted Successfully");
      //   //this._onApproveSuccess();
      // } catch (e) {
      //   console.log(e);
      //   this.$snack.success("Error accepting approval request");
      // }
      // try {
      //   let res = await this.changeApprovalStatusV2({
      //     id: this.project.id,
      //     approval_status: "APPROVED",
      //     tasks: [this.selectedTask]
      //   });
      //   this.$snack.success("Accepted Successfully");
      //   this._onApproveSuccess();
      // } catch (e) {
      //   console.log(e);
      //   this.$snack.success("Error accepting approval request");
      // }
    },

    _onPaymentSuccess() {
      //if owner, show approval request screen
      // if (this.project && this.project.user_owner.user.id == this.profile.id) {
      //   this.showApproval = true; //depreciated
      //   this.showFinance = false;
      // } else {
      //   this.showApproval = false; ////depreciated
      //   this.showFinance = false;
      // }
      this.$snack.success(
        "You have successfully paid the selected tasks. Thank You"
      );
      this.showAcceptance = false;

      this.refreshRecords();
    },

    _onUpdateCardSuccess() {
      this.$snack.success(
        "You have successfully updated the card details. Thank You"
      );
      this.showCardUpdate = false;

      this.refreshRecords();
    },

    _onInviteSuccess() {
      //if owner, show approval request screen
      this.showApproval = false; // //depreciated
      this.showFinance = false;

      this.refreshRecords();
    },

    _onApproveSuccess() {
      //if owner, show approval request screen
      this.showApproval = false;
      this.showAcceptance = false;
      this.refreshRecords();
    },

    handleAssignedByUserClicked(id, userId, task) {
      console.log(task, id, "avatar clicked");
      if (task.permission && task.permission.edit == 1) {
        //this.$emit("assignedByUserClicked", id, userId, task);
        this.modal = {
          ...this.modal,
          task: task,
          title: "Search New Assigned By User",
          assignedBy: true,
          role: "ASSIGNER"
        };
      } else {
        this.$snack.success("You can not edit this task.");
      }
    }
  }
};
</script>
<style>
.starter-page {
  min-height: calc(100vh - 380px);
}

.project-header {
  display: flex;
  flex-direction: row;
  padding: 10px 16px;
}
.topRightCorner {
  position: absolute;
  right: 0;
  margin-right: 7px;
  margin-top: -1px;
}
.view-mode a:not(:last-child) {
  margin-right: 10px;
}
.view-mode a {
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
}
.view-mode a:hover {
  color: #24a46d !important;
}
.view-mode {
  margin-right: 15px;
}
@media screen and (min-width: 768px) {
  .project-header {
    padding: 10px 32px;
  }
}
@media screen and (max-width: 768px) {
  .topRightCorner {
    position: absolute;
    right: 0;
    margin-right: 7px;
    margin-top: -9px;
  }
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  transform: translate(0, 100%);
}
.slide-leave-to {
  transform: translate(0, 100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.project-header button {
  margin-right: 3px;
}

.company-logo-with-text {
  padding-left: 10px;
}
.company-logo-with-text [aria-label] {
  position: relative;
}

.company-logo-with-text [aria-label]:after {
  content: attr(aria-label);
  display: none;
  position: absolute;
  top: 150%;
  left: 0px;
  z-index: 5000;
  pointer-events: none;
  padding: 15px;
  line-height: 15px;
  white-space: nowrap;
  text-decoration: none;
  overflow: visible;
  font-size: 14px;
  font-weight: normal;
  color: #000;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 1px 2px 6px rgba(109, 109, 109, 0.3);
}

.company-logo-with-text [aria-label]:hover:after,
[aria-label]:focus:after {
  display: block;
}
.company-logo-with-text .company-logo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 16px;
  line-height: 30px;
  border: 2px solid #4cce88;
  display: inline-block;
  overflow: hidden;
  text-align: center;
  color: #4cce88;
  vertical-align: middle;
}
.company-logo-with-text .company-logo img {
  width: 100%;
  height: 100%;
  vertical-align: baseline;
}
</style>
